import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Toaster } from '@layerit/ui/components/ui/sonner'
import { createQueryClient } from '@web/query'
import { routeElements } from '@web/routes'
import './styles.css'

const container = document.getElementById('root')
if (!container) {
	throw new Error('#root is missing from index.html')
}

const queryClient = createQueryClient()

const router = createBrowserRouter(routeElements)

createRoot(container).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
			<Toaster />
		</QueryClientProvider>
	</StrictMode>,
)
